import React, { useEffect, useState } from "react";
// import { actions } from "../../actions";
// import { useSelector, useDispatch } from "react-redux";
import {
  Modal,
  Input,
  Button,
  Select,
  Card,
  Statistic,
  Empty,
  Pagination,
  Space,
} from "antd";
import {
  StarOutlined,
  CalendarOutlined,
  EyeOutlined,
  FileTextOutlined,
  CheckCircleOutlined,
  BarChartOutlined,
  SafetyCertificateOutlined,
  ArrowLeftOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./nujobsEvalDashboard.scss";
import NuJobsDashboardEvalCard from "../nujobsDashboardEvalCard";
import NuJobsMyEvalsCard from "../nujobsMyEvalsCard";
import useNuJobsStore from "../../../store/nujobsevals.store";
import { FILTER_DURATION_OPTIONS } from "../../../helper/categoryconstants";
// import useQSetStore from "../../store/qset.store";

function NuJobsEvalDashboard() {
  const location = useLocation();
  const navigate = useNavigate();
  const [currentView, setCurrentView] = useState("AllEvals");
  const [evalFilters, setEvalFilters] = useState({
    skill: null,
    state: "Live",
    duration: null,
    level: null,
  });
  const [favouriteEvals, setFavouriteEvals] = useState([]);
  const [totalFavouriteEvals, setTotalFavouriteEvals] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(12);

  // NEW: State to track if a search is actively applied
  const [isSearchActive, setIsSearchActive] = useState(false);

  const {
    allGlobalEvals,
    getAllGlobalEvals,
    getQuestionsForEvaluation,
    getMyEvals,
    myEvals,
    getFavouriteEvals,
    myFavouriteEvalIDs,
    myFavouriteEvals,
    nujobsEvalPagination,
    totalEvals,
  } = useNuJobsStore();

  useEffect(() => {
    async function fetchData() {
      await getAllGlobalEvals(evalFilters);
      await getFavouriteEvals();
      const favEvals = useNuJobsStore.getState().myFavouriteEvalsIDs || [];
      setFavouriteEvals(favEvals);
      //console.log("Fetched Favourite Evals:", favEvals);
      setTotalFavouriteEvals(favEvals.length);
    }
    fetchData();
  }, [currentView]);

  useEffect(() => {
    if (currentView === "AllEvals") {
      getMyEvals();
    }
  }, [currentView]);

  const handleFilterChange = (key, value) => {
    const updatedFilters = { ...evalFilters, [key]: value };
    setEvalFilters(updatedFilters);
  };

  // NEW: Handler for Search Marketplace button
  const handleSearch = () => {
    if (evalFilters.skill && evalFilters.skill.trim() !== "") {
      setIsSearchActive(true);
    } else {
      setIsSearchActive(false);
    }
    getAllGlobalEvals(evalFilters);
  };

  // NEW: Handler to reset the search
  const handleResetSearch = () => {
    const resetFilters = { ...evalFilters, skill: null };
    setEvalFilters(resetFilters);
    setIsSearchActive(false);
    getAllGlobalEvals(resetFilters);
  };

  // 2. Evaluation Level Options
  const levelOptions = [
    { label: "Entry Level", value: "entry" },
    { label: "Mid Level", value: "mid" },
    { label: "Senior Level", value: "senior" },
    { label: "Lead / Principal", value: "lead" },
  ];

  const stats = [
    {
      title: "Taken",
      value: myEvals?.length || 0,
      icon: <CheckCircleOutlined />,
      color: "#52c41a",
      onClick: () => setCurrentView("MyEvals"),
    },
    {
      title: "Favourites",
      value: totalFavouriteEvals,
      icon: <StarOutlined />,
      color: "#d97706",
      onClick: () => setCurrentView("FavEvals"),
    },
    {
      title: "Category",
      value: 5,
      icon: <BarChartOutlined />,
      color: "#ff4d4f",
    },
    {
      title: "Badges",
      value: 8,
      icon: <SafetyCertificateOutlined />,
      color: "#faad14",
    },
    {
      title: "Beginner",
      value: 5,
      icon: <BarChartOutlined />,
      color: "#4dbeff",
    },
    {
      title: "Intermediate",
      value: 1,
      icon: <BarChartOutlined />,
      color: "#fff64d",
    },
    {
      title: "Advanced",
      value: 2,
      icon: <BarChartOutlined />,
      color: "#ff974d",
    },
    {
      title: "Expert",
      value: 1,
      icon: <BarChartOutlined />,
      color: "#ff4d4f",
    },
  ];

  const handlePageChange = (page, pageSize) => {
    getAllGlobalEvals({ ...evalFilters, page, limit: pageSize });
    setCurrentPage(page);
    setLimit(pageSize);
  };

  return (
    <>
      <div className="nujobsEvaluationSearch-wrapper">
        <div className="nujobsEvaluationSearch-serach-container">
          <div className="nujobsEvaluationSearch-search-wrapper">
            <Input
              className="nujobListing-search-item"
              type="text"
              placeholder={"Type to search"}
              value={evalFilters.skill || ""}
              onChange={(e) =>
                setEvalFilters({ ...evalFilters, skill: e.target.value })
              }
            />

            <Space>
              <Button
                className="nujobListing-search-button"
                onClick={handleSearch}
              >
                Search Marketplace
              </Button>

              {/* NEW: Show Reset Search button if a search is active */}
              {isSearchActive && (
                <Button
                  className="nujobListing-reset-button"
                  icon={<DeleteOutlined />}
                  onClick={handleResetSearch}
                >
                  Clear Search
                </Button>
              )}
            </Space>
          </div>
        </div>

        {/* NEW: Hide Evaluation Stats if a search is active */}
        {!isSearchActive && (
          <div className="nujobsEvaluationSearch-container">
            <div className="nujobsEvaluationSearch-title">
              Evaluations Stats
            </div>
            <div className="stats-grid">
              {stats.map((item) => (
                <Card
                  key={item.title}
                  hoverable
                  className="dashboard-stat-card"
                  onClick={item.onClick ? item.onClick : undefined}
                >
                  <div className="dashboard-stat-content">
                    <div
                      className="dashboard-stat-icon"
                      style={{
                        background: `${item.color}15`,
                        color: item.color,
                      }}
                    >
                      {item.icon}
                    </div>

                    <Statistic title={item.title} value={item.value} />
                  </div>
                </Card>
              ))}
            </div>
          </div>
        )}

        {currentView === "AllEvals" ? (
          <div className="nujobsEvaluationSearch-container">
            <div className="nujobsEvaluationSearch-title">Evaluations</div>
            <div className="nujobsEvaluationSearch-filters">
              <Space size="middle" wrap style={{ marginBottom: 16 }}>
                {/* Evaluation Duration Filter */}
                <Select
                  placeholder="Evaluation Duration"
                  style={{ width: 200 }}
                  options={FILTER_DURATION_OPTIONS}
                  allowClear
                  onChange={(value) => handleFilterChange("duration", value)}
                />

                {/* Evaluation Level Filter */}
                <Select
                  placeholder="Evaluation Level"
                  style={{ width: 180 }}
                  options={levelOptions}
                  allowClear
                  onChange={(value) => handleFilterChange("level", value)}
                />
              </Space>
            </div>

            {/* NEW: Only show the evaluations found string if a search is active */}
            {isSearchActive && (
              <div
                className="nujobsEvaluationSearch-container"
                style={{ marginBottom: "10px" }}
              >
                <strong>({totalEvals || 0}) Evaluations Found</strong>
              </div>
            )}

            <div className="eval-container">
              {allGlobalEvals?.length > 0 ? (
                allGlobalEvals?.map((item, idx) => (
                  <NuJobsDashboardEvalCard
                    key={idx}
                    evalItem={item}
                    questionsArray={""}
                    setFavouriteEvals={setFavouriteEvals}
                    favouriteEvals={favouriteEvals}
                    setTotalFavouriteEvals={setTotalFavouriteEvals}
                  />
                ))
              ) : (
                <Empty description="No evaluations live." />
              )}
            </div>
          </div>
        ) : currentView === "MyEvals" ? (
          <div className="nujobsEvaluationSearch-container">
            <div className="nujobsEvaluationSearch-title">
              <Button
                type={"Back"}
                icon={<ArrowLeftOutlined />}
                onClick={() => setCurrentView("AllEvals")}
              />
              Taken Evaluations
            </div>
            <div className="eval-container">
              {myEvals?.map((evalItem, idx) => (
                <NuJobsMyEvalsCard key={idx} evalItem={evalItem} />
              ))}
            </div>
          </div>
        ) : currentView === "FavEvals" ? (
          <div className="nujobsEvaluationSearch-container">
            <div className="nujobsEvaluationSearch-title">
              <Button
                type={"Back"}
                icon={<ArrowLeftOutlined />}
                onClick={() => setCurrentView("AllEvals")}
              />
              Favourite Evaluations
            </div>
            <div className="eval-container">
              {myFavouriteEvals?.length > 0 ? (
                myFavouriteEvals?.map((item, idx) => (
                  <NuJobsDashboardEvalCard
                    key={idx}
                    evalItem={item}
                    questionsArray={""}
                    setFavouriteEvals={setFavouriteEvals}
                    favouriteEvals={favouriteEvals}
                    setTotalFavouriteEvals={setTotalFavouriteEvals}
                  />
                ))
              ) : (
                <Empty description="You haven't saved any evaluations" />
              )}
            </div>
          </div>
        ) : null}

        <div className="nujobsEvaluationSearch-pagination">
          <Pagination
            style={{
              marginTop: "4px",
              float: "inline-end",
              marginBottom: "20px",
            }}
            current={currentPage}
            pageSize={limit}
            total={nujobsEvalPagination?.total || 0}
            onChange={handlePageChange}
            showSizeChanger
            pageSizeOptions={[12, 20, 50, 100, 150]}
          />
        </div>
      </div>
    </>
  );
}

export default NuJobsEvalDashboard;
